import React from 'react';

import * as LabelPrimitive from '@radix-ui/react-label';

import { cn } from './utils';


/** Field label — sits ABOVE the field (DESIGN.md `field-label`). */
const Label = React.forwardRef((props, ref) => {
  const { className, ...restProps } = props;
  return (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(
        'text-xs font-medium tracking-[0.2px] text-ink-subtle',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        className,
      )}
      {...restProps}
    />
  );
});

Label.displayName = 'Label';

export { Label };
export default Label;
